import styled from 'styled-components'
import { tokens } from 'styling/tokens'
import { BodyText, Head1 } from 'styling/Typography'

export const PageTitle = styled(Head1)`
  font-size: 1.5rem;
  line-height: 1.3;
  color: ${tokens.text.primary};
`

export const SubTitle = styled(BodyText)`
  color: ${tokens.text.muted};
  margin-bottom: 1rem;
`

export const DeptKey = styled.span`
  font-family: 'Courier New', monospace;
  font-size: 0.75rem;
  color: ${tokens.text.muted};
`

export const TemplateSelect = styled.select`
  min-width: 9rem;
  padding: 0.375rem 0.625rem;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.inset};
  color: ${tokens.text.primary};
  font-size: ${tokens.font.body};
  text-transform: capitalize;
  outline: none;
  cursor: pointer;
  transition: border ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    border: 1px solid ${tokens.border.strong};
  }

  &:focus {
    border: 1px solid ${tokens.accent.base};
  }

  option {
    background: ${tokens.surface.raised};
    color: ${tokens.text.primary};
    text-transform: capitalize;
  }
`

export const OrderInputWrap = styled.div`
  width: 4.5rem;
`

export const InfoNote = styled.div`
  margin-top: 1rem;
  padding: 0.625rem 0.875rem;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.inset};
`
